import { PropsWithChildren, useEffect, useState } from "react";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";

export function PostsPromoListArea({
    area,
    children,
}: PropsWithChildren<{
    area: string | "above-bets" | "below-bets";
}>) {
    const { getConfigs } = useGlobalConfigs();
    const [enabled, setEnabled] = useState(false);
    useEffect(() => {
        if (!getConfigs()?.tippspielPromotionSegmentPosition) {
            return;
        }

        if (getConfigs()?.tippspielPromotionSegmentPosition !== area) {
            return;
        }
        setEnabled(true);
    }, [getConfigs]);

    return <>{enabled && children}</>;
}
